import React from 'react';
import { CHIPOTLE_CONTENT_LOOK } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content-look';
import Footer, { Props as FooterProps } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/footer';
import { FooterLink } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/footer/components/column';

interface Props {
  data: FooterProps & {
    headerCol1: string;
    linksCol1: FooterLink[];
    headerCol2: string;
    linksCol2: FooterLink[];
    headerCol3: string;
    linksCol3: FooterLink[];
    headerCol4: string;
    linksCol4: FooterLink[];
  };
}

const FooterTastic = ({ data }: Props) => {
  const columns = [
    {
      header: data.headerCol1,
      links: data.linksCol1,
    },
    {
      header: data.headerCol2,
      links: data.linksCol2,
    },
    {
      header: data.headerCol3,
      links: data.linksCol3,
    },
    {
      header: data.headerCol4,
      links: data.linksCol4,
    },
  ];

  return (
    <div className="fixed-screen-width lg:relative-width">
      <Footer {...data} columns={columns} columnHeaderClassName={CHIPOTLE_CONTENT_LOOK.footerColumnHeaderClassName} />
    </div>
  );
};

export default FooterTastic;
